import React, { Component } from 'react'

export default class ButtonTrigger extends Component {
  render() {
  	const active = this.props.active ? ' active' : ''
		
		return (
			<button onClick={this.props.onClick} type="submit" className={`btn-search${active}`}><span>Search</span><i className="fa fa-search"></i></button>
		)
	}
}
